import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import moment from 'moment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MomentUtils from '@date-io/moment';
import {
  DASHBOARD_REST_TABLES_INFO_VIEW,
  DASHBOARD_REST_VIEW,
  DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  NO_TABLE,
  REST_RESERVATION_CREATE,
} from '../../../../constants/DashboardConst';
import { useSelector, useDispatch } from 'react-redux';
import {
  dashboardFilterDateSelector,
  restaurantDashboardReservationsSelector,
  restaurantDashboardReservationTableSelector,
  restaurantTimingsSelector,
  setDashboardFilterDate,
  setTimings,
} from '../../DashboardSlice';
import './DashboardRestaurantTables.scss';
import DashboardRestaurantTableView from './DashboardRestaurantTableView';
import { getRestaurantTiming, getTableStatus } from '../../../../utils/dashboardUtils';

const DashboardRestaurantTables = (props) => {
  const {
    onDrawerToggle,
    hotelId,
    onViewToggle,
    obj,
    setIsFromTables,
    restaurantId,
    selectedRestaurant,
  } = props;
  const dispatch = useDispatch();
  const restaurantDashboardReservationTable = useSelector(
    restaurantDashboardReservationTableSelector,
  );
  const restaurantTimeList = useSelector(restaurantTimingsSelector);
  const restaurantDashboardReservations = useSelector(restaurantDashboardReservationsSelector);
  const date = useSelector(dashboardFilterDateSelector);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    type: '',
  });
  const [restaurantReservations, setRestaurantReservations] = useState([]);

  useEffect(() => {
    const reservationsTableNumbers = [];
    const selectedDate = moment(date.formatDate, DATE_FORMAT).format('YYYY-MM-DD');
    const currReservations = restaurantDashboardReservations.filter(
      (reservations) => reservations.date === selectedDate,
    );
    const currTable = restaurantDashboardReservationTable.map((tableDetails) => {
      const tableStatus = getTableStatus(tableDetails, currReservations, selectedDate);
      return { ...tableDetails, status: tableStatus.status };
    });
    const currRestaurantTime = getRestaurantTiming(selectedDate, selectedRestaurant);
    dispatch(setTimings(currRestaurantTime));
    const sortTableNumber = currTable
      ?.slice()
      .sort((tn1, tn2) => tn1.tableNumber - tn2.tableNumber);
    sortTableNumber.forEach((restaurantTable) => {
      currRestaurantTime.forEach((restaurantTime) => {
        const tableNdx = reservationsTableNumbers.findIndex(
          (tableData) => tableData.tableNumber === restaurantTable.tableNumber,
        );
        const start = moment(restaurantTime, 'hh A').format('HH:mm');
        const end = moment(restaurantTime, 'hh A').add(1, 'hour').format('HH:mm');
        if (tableNdx > -1) {
          reservationsTableNumbers[tableNdx].timings.push({
            start,
            end,
            details:
              currReservations.length > 0
                ? getTableReservationsDetails(
                    restaurantTable.tableNumber,
                    `${selectedDate} ${start}`,
                    `${selectedDate} ${end}`,
                    currReservations,
                    reservationsTableNumbers,
                  )
                : null,
            tableStatus: restaurantTable.status,
          });
        } else {
          reservationsTableNumbers.push({
            tableNumber: restaurantTable.tableNumber,
            timings: [
              {
                start,
                end,
                details:
                  currReservations.length > 0
                    ? getTableReservationsDetails(
                        restaurantTable.tableNumber,
                        `${selectedDate} ${start}`,
                        `${selectedDate} ${end}`,
                        currReservations,
                        reservationsTableNumbers,
                      )
                    : null,
                tableStatus: restaurantTable.status,
              },
            ],
          });
        }
      });
    });
    setRestaurantReservations(reservationsTableNumbers);
  }, [restaurantDashboardReservationTable, restaurantDashboardReservations, date]);

  const getTableReservationsDetails = (
    tableNumber,
    startTime,
    endTime,
    reservationsList,
    resTableNumber,
  ) => {
    const reservationsDetail = reservationsList.find((reservation) => {
      const isSameTable = reservation.tableNumbers.some(
        (currTableNumber) => currTableNumber === tableNumber,
      );
      if (!isSameTable) return false;
      const startTiming = moment(startTime, 'YYYY-MM-DD HH:mm');
      const endTiming = moment(endTime, 'YYYY-MM-DD HH:mm');
      const bookingStart = moment(
        `${reservation.date} ${reservation.reserveFrom}`,
        'YYYY-MM-DD HH:mm',
      );
      const bookingEnd = moment(
        `${reservation.date} ${reservation.reserveUntil}`,
        'YYYY-MM-DD HH:mm',
      );
      const isBetweenStart = startTiming.isBetween(bookingStart, bookingEnd);
      const isBetweenEnd = endTiming.isBetween(bookingStart, bookingEnd);
      const isEqual = startTiming.isSame(bookingStart);
      const isBeforeEndTime = startTiming.isBefore(bookingEnd);
      const isAfterStart = endTiming.isAfter(bookingStart);
      if (isBetweenStart || isBetweenEnd || isEqual || (isBeforeEndTime && isAfterStart)) {
        const sameRev = resTableNumber.some((tableNumberDetails) => {
          return tableNumberDetails.timings.some(
            (timings) =>
              timings?.details?.id === reservation.id &&
              tableNumberDetails.tableNumber === tableNumber,
          );
        });
        if (sameRev) return false;
        return true;
      }
      return false;
    });
    if (reservationsDetail) return reservationsDetail;
    return null;
  };

  const onChangeDate = (selectedDate) => {
    const currentDate = { ...date };
    currentDate.displayDate = moment(selectedDate).format(DISPLAY_DATE_FORMAT);
    currentDate.formatDate = moment(selectedDate).format(DATE_FORMAT);
    dispatch(setDashboardFilterDate(currentDate));
  };

  useEffect(() => {
    onChangeDate(moment());
  }, []);

  const renderInput = (textFieldProps) => (
    <Button
      variant='outlined'
      color='secondary'
      size='small'
      endIcon={<KeyboardArrowDownIcon />}
      onClick={() => textFieldProps.onClick()}
      className='me-2 date-view-btn'
    >
      {moment(date.formatDate, DATE_FORMAT).format('Do MMM YYYY')}
    </Button>
  );

  const onClickBack = () => {
    let viewType = obj?.id ? DASHBOARD_REST_VIEW : null;
    let viewStatus = obj?.id ? true : false;
    let viewObj = obj?.id ? obj : null;
    return onViewToggle(viewType, viewStatus, viewObj);
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.location);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      type: '',
      description: '',
      status: false,
      anchorEl: null,
      location: null,
    });
  };

  const onClickAddTable = () => {
    setIsFromTables(true);
    onViewToggle(DASHBOARD_REST_TABLES_INFO_VIEW, true, obj);
  };

  return (
    <div className='container dashboard-restaurant-table-view'>
      <div className='pb-2 d-flex gap-2 flex-wrap'>
        <div className='col px-0 d-flex align-items-center'>
          <Button
            variant='text'
            color='secondary'
            size='large'
            startIcon={<ArrowBackIcon fontSize='medium' />}
            className='me-2'
            onClick={() => onClickBack()}
          >
            Back
          </Button>
          <span className='page-title'>{'Tables'}</span>
        </div>
        <div className='col px-0 d-flex align-items-end justify-content-end'>
          <Button
            variant='outlined'
            color='secondary'
            size='large'
            className='me-2 table-info-btn'
            onClick={() => onViewToggle(DASHBOARD_REST_TABLES_INFO_VIEW, true, obj)}
          >
            Table Info
          </Button>
          <Button
            variant='outlined'
            color='secondary'
            size='large'
            className='me-2 add-reservation-btn'
            onClick={(e) => {
              onOpenDrawer(e, REST_RESERVATION_CREATE);
            }}
          >
            Add Reservation
          </Button>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker
              autoOk
              variant='dialog'
              value={moment(date.formatDate, DATE_FORMAT)}
              onChange={(date) => onChangeDate(date)}
              TextFieldComponent={renderInput}
              animateYearScrolling
              DialogProps={{ className: 'date-picker-time-line' }}
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
      {restaurantDashboardReservationTable.length > 0 ? (
        <>
          <DashboardRestaurantTableView
            restaurantReservations={restaurantReservations}
            restaurantDashboardReservationTable={restaurantDashboardReservationTable}
            date={date.formatDate}
            restaurantId={restaurantId}
            hotelId={hotelId}
            restaurantTime={restaurantTimeList}
            onDrawerToggle={onDrawerToggle}
          />
          <div className='d-flex status-color-info justify-content-around'>
            <div className='d-flex align-items-center w-100'>
              <div className='info-circle info-circle-reserved'></div>
              <div className='mx-2'>Reserved</div>
            </div>
            <div className='d-flex align-items-center w-100'>
              <div className='info-circle info-circle-occupied'></div>
              <div className='mx-2'>Occupied</div>
            </div>
            <div className='d-flex align-items-center w-100'>
              <div className='info-circle info-circle-inactive'></div>
              <div className='mx-2'>Inactive</div>
            </div>
          </div>
        </>
      ) : (
        <div className='py-2 card shadow'>
          <div className='no-table'>
            <p className='no-table-title'>
              Nothing to see here <span className='no-table-title-exclamation-mark'>!</span>
            </p>
            <img src={NO_TABLE} alt='no-table' />
            <p className='no-table-description'>
              To view Table reservations and Slots information, please add tables to get started.
            </p>
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<AddCircleIcon />}
              onClick={() => onClickAddTable()}
            >
              Add Table
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardRestaurantTables;
